import { Button, Divider, TextField, Typography } from "@mui/material";
import "../Package/CreatePackage.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Formik, Form, ErrorMessage } from "formik";
import Grid2 from "@mui/material/Grid2";
import PackageDetailsForm from "./PackageDetailForm.jsx";
import { createPackageValidationSchema } from "../../utils/schema/validations.js";
import PickupAddressForm from "./PickupAddressForm.jsx";
import DeliveryAddressForm from "./DeliveryAddressForm.jsx";
import packageCrud from "../../utils/services/PackageCRUD.api.js";
import {
  fetchPackageDetailsAdapter,
  packageRequestAdapter,
  setStorageValue,
} from "../../utils/helper.js";
import { BasicLayout } from "../../layouts/BasicLayout";
import { useEffect, useState } from "react";
import { GOOGLE_API_KEY_CREATE_PACK } from "../../data/APIEndpoints.js";
import AlertMessage from "../../components/common/AlertMessage.jsx";
import { useNavigate, useParams, useLocation } from "react-router";
import ConfirmationPopup from "../../components/common/ConfirmationPopup.jsx";
import { getStorageValue } from "../../utils/helper.js";
import NotificationsListAPI from "../../utils/services/notifications.api.js";
import Loaders from "../../components/common/Loaders.jsx";
import SuccessDialog from "../../components/common/SuccessDialog.jsx";

const CreatePackage = ({ type }) => {
  const location = useLocation();
  const Geocode = require("react-geocode");
  const { id } = useParams();
  const userId = getStorageValue("userId");

  const packageType = type || "create";
  const [formValues, setFormValues] = useState([]);
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isShowNotifications, setShowNotifications] = useState(false);
  const { checkUnreadNotifications } = NotificationsListAPI;

  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = (confirmed) => {
    setIsPopupOpen(false);
    if (confirmed) {
      if(packageType === "create") {
        if(location?.state?.backURL && (location?.state?.backURL === "/MyDelivery" || location?.state?.backURL === "/MyRequest" || location?.state?.backURL === "/dashboard")) {
          navigate(location?.state?.backURL, { state: { status: location?.state?.status}});
        } else if(location?.state?.backURL && location?.state?.backURL === `/users/${location?.state?.userId}`) {
          navigate(location?.state?.backURL, { state: 
            { 
              tab: location?.state?.tab,
              statusId: location?.state?.statusId,
              userData: location?.state?.userData
            }
          });
        } else if(location?.state?.backURL) {
          navigate(location?.state?.backURL);
        } else {
          setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
          navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
        }
      } else {
        if(location?.state?.backNavigationURL) {
          navigate(location?.state?.backNavigationURL, {
            state: {
              backURL: location?.state?.backURL,
              tab: location?.state?.tab,
              statusId: location?.state?.statusId,
              userData: location?.state?.userData,
              originPage: location?.state?.originPage,
            }
          });
        } else if(location?.state?.backURL){
          if(location?.state?.backURL && (location?.state?.backURL === "/MyDelivery" || location?.state?.backURL === "/MyRequest" || location?.state?.backURL === "/dashboard")) {
            navigate(location?.state?.backURL, { state: { status: location?.state?.status}});
          } else {
            setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
            navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
          }
        } else {
          setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
          navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
        }
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccessClose = () => {
    setSuccessOpen(false);
    if (packageType === "create") {
      setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
      setStorageValue("package:tab", 1);
      setStorageValue("DeliveryTabs", getStorageValue("roleId") === "1" ? getStorageValue("DeliveryTabs") : 0);
      navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
      setStorageValue("updatePhase","");
    } else {
      if(location?.state?.backNavigationURL) {
        navigate(location?.state?.backNavigationURL, {
          state: {
            backURL: location?.state?.backURL,
            tab: location?.state?.tab,
            statusId: location?.state?.statusId,
            userData: location?.state?.userData,
            originPage: location?.state?.originPage,
          }
        });
      } else if(location?.state?.backURL){
        if(location?.state?.backURL && (location?.state?.backURL === "/MyDelivery" || location?.state?.backURL === "/MyRequest" || location?.state?.backURL === "/dashboard")) {
          navigate(location?.state?.backURL, { state: { status: location?.state?.status}});
        } else {
          setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
          navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
        }
      } else {
        setStorageValue("menuName", getStorageValue("roleId") === "1" ? "Admin" : "My Delivery");
        navigate(getStorageValue("roleId") === "1" ? "/dashboard" : "/MyDelivery");
      }
      setStorageValue("updatePhase","");
    }
  };

  /**
   * fetches the latitude and longitude using geocode for pickup address
   * @param {*} address - pickup address
   * @param {*} setFieldValue - form field set function
   */
  const fetchCoordinatesPickUp = async (address, setFieldValue) => {
    const pickupAddress = `${address.pickupAddress},${address.pickupCity},${address.pickupState},${address.pickupZipcode}`;
    const response = await Geocode.fromAddress(pickupAddress);
    const { lat, lng } = response.results[0].geometry.location;
    setFieldValue("pickupLatitude", lat);
    setFieldValue("pickupLongitude", lng);
  };

  /**
   * fetches the latitude and longitude using geocode for delivery address
   * @param {*} address - delivery address
   * @param {*} setFieldValue - form field set function
   */
  const fetchCoordinatesDelivery = async (address, setFieldValue) => {
    const deliveryAddress = `${address.deliveryAddress},${address.deliveryCity},${address.deliveryState},${address.deliveryZipcode}`;
    const response = await Geocode.fromAddress(deliveryAddress);
    const { lat, lng } = response.results[0].geometry.location;
    setFieldValue("deliveryLatitude", lat);
    setFieldValue("deliveryLongitude", lng);
  };

  const handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      const checkDate = new Date()?.toISOString();
        const response = await checkUnreadNotifications(userId, checkDate);
        if(response?.data?.message) {
          localStorage.removeItem("isClicked");
          setStorageValue("isReload", response?.data?.message);
          setStorageValue("notifications", response?.data?.message);
          setShowNotifications(response?.data?.message);
        }
    } 
  };

  useEffect(() => {
    Geocode.setKey(GOOGLE_API_KEY_CREATE_PACK);

    if (packageType === "edit") {
      fetchPackage(id);
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line
  }, []);


  // Handle popstate event to manage browser back action
  useEffect(() => {
    const handlePopState = (event) => {
      if (!isPopupOpen) {
        // Open the popup when back button is pressed
        setIsPopupOpen(true);
      } else {
        // If the popup is open, let the user navigate away
        window.history.pushState(null, "", window.location.href);
      }
    };

    // Add popstate listener to handle backward navigation
    window.addEventListener("popstate", handlePopState);

    // Create an initial history state to manage navigation
    window.history.pushState(null, "", window.location.href);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isPopupOpen]);

  /**
   * handles the save
   * @param {*} packageDetails - entered package details
   */
  const handleSubmit = async (packageDetails) => {
    setIsDisabled(true);
    if (
      packageDetails?.pickupAddress?.trim() ===
        packageDetails?.deliveryAddress?.trim() &&
      packageDetails?.pickupCity === packageDetails?.deliveryCity &&
      packageDetails?.pickupState === packageDetails?.deliveryState &&
      packageDetails?.pickupZipcode === packageDetails?.deliveryZipcode
    ) {
      setAlertSeverity("error");
      setAlertMessage("Source and destination addresses cannot be the same.");
      setOpen(true);
      setIsDisabled(false);
    } else {
      // Wait for both coordinate fetches to complete
      await Promise.all([
        fetchCoordinatesPickUp(
          packageDetails,
          (field, value) => (packageDetails[field] = value)
        ),
        fetchCoordinatesDelivery(
          packageDetails,
          (field, value) => (packageDetails[field] = value)
        ),
      ]);
      const requestDetails = packageRequestAdapter(
        packageDetails,
        packageType,
        id
      );
      if (packageType === "create") {
        createPackage(requestDetails);
      } else {
        editPackage(requestDetails);
      }
    }
  };

  /**
   * fetches the package for edit flow
   * @param {*} jobId - package ID
   */
  const fetchPackage = async (jobId) => {
    const response = await packageCrud.getPackageById(jobId);
    if (response.status === "success") {
      const details = fetchPackageDetailsAdapter(response.data);
      setFormValues(details);
    } else {
      setAlertSeverity(response.status);
      setAlertMessage(response?.error?.response?.data?.message || "Failed getting package details");
      setOpen(true);
    }
  };

  /**
   * creates package
   * @param {*} packageDetails - entered package details
   */
  const createPackage = async (packageDetails) => {
    setLoading(true);
    setIsDisabled(true);
    const response = await packageCrud.postCreatePackage(packageDetails);
    if (response.status === "success") {
      setLoading(false);
      setFormValues(response.data);
      setAlertSeverity(response.status);
      setAlertMessage(`Job created successfully ${response.data.uniqueId}`);
      setSuccessOpen(true);
      setStorageValue("updatePhase","Updated");
    } else {
      setLoading(false);
      setAlertSeverity(response.status);
      setAlertMessage(response.message);
      setOpen(true);
      setIsDisabled(false);
    }
  };

  /**
   * updates package
   * @param {*} packageDetails - entered package details
   */
  const editPackage = async (packageDetails) => {
    setLoading(true);
    setIsDisabled(true);
    const response = await packageCrud.editPackage(packageDetails);
    if (response.status === "success") {
      setLoading(false);
      setAlertSeverity(response.status);
      setAlertMessage(`Job updated successfully ${id}`);
      setSuccessOpen(true);
      setStorageValue("updatePhase","Updated");
    } else {
      setLoading(false);
      setAlertSeverity(response.status);
      setAlertMessage(response?.error?.response?.data?.message ? response?.error?.response?.data?.message : response?.message);
      setOpen(true);
      setIsDisabled(false);
    }
  };

  return (
    <BasicLayout isShowNotifications={isShowNotifications}>
      <div className="create-package-container">
        <Button
          sx={{ 
            color: "#2579CD", 
            textTransform: "none", 
            px: "0",
            "&:disabled": {
              color: "#2579CD"
            }
          }}
          variant="none"
          size="medium"
          startIcon={<ArrowBackIcon />}
          onClick={handleOpenPopup}
          disabled={isDisabled}
        >
          Back
        </Button>
        <Typography variant="h6">
          {packageType === "create" ? "Create New Package" : "Edit Package"}
        </Typography>
        <Divider sx={{ borderColor: "#E6EDFF", mt: 3, mb: 2 }} />
        <Formik
          enableReinitialize={true}
          initialValues={{
            packageName: formValues.packageName || "",
            description: formValues.description || "",
            height: formValues.height || "",
            width: formValues.width || "",
            depth: formValues.depth || "",
            weight: formValues.weight || "",
            expiryDate: formValues.expiryDate || "",
            pickupFullName: formValues.pickupFullName || "",
            pickupPhoneNumber: formValues.pickupPhoneNumber || "",
            pickupAddress: formValues.pickupAddress || "",
            pickupCity: formValues.pickupCity || "",
            pickupState: formValues.pickupState || "",
            pickupZipcode: formValues.pickupZipcode || "",
            pickupLatitude: formValues.pickupLatitude || 0,
            pickupLongitude: formValues.pickupLongitude || 0,
            deliveryFullName: formValues.deliveryFullName || "",
            deliveryPhoneNumber: formValues.deliveryPhoneNumber || "",
            deliveryAddress: formValues.deliveryAddress || "",
            deliveryCity: formValues.deliveryCity || "",
            deliveryState: formValues.deliveryState || "",
            deliveryZipcode: formValues.deliveryZipcode || "",
            deliveryLatitude: formValues.deliveryLatitude || 0,
            deliveryLongitude: formValues.deliveryLongitude || 0,
            specialInstructions: formValues.specialInstructions || "",
            autofillPickupAddress: formValues?.autofillPickupAddress || false,
            autofillDeliveryAddress: formValues?.autofillDeliveryAddress || false,
          }}
          validationSchema={createPackageValidationSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({
            handleChange,
            handleBlur,
            values,
            setFieldValue,
            setErrors,
            touched,
            errors,
            setFieldTouched,
            setFieldError 
          }) => (
            <Form autoComplete="off">
              {loading && (
                <Loaders />
              )}
              <PackageDetailsForm
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                touched={touched}
                errors={errors}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
              />
              <PickupAddressForm
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                touched={touched}
                errors={errors}
                setErrors={setErrors}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
              />
              <DeliveryAddressForm
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                touched={touched}
                errors={errors}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
              />
              <Typography sx={{ mt: 2, mb: 2 }} variant="h6">
                Special Instructions(Optional)
              </Typography>
              <Grid2
                size={{ xs: 12 }}
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                }}
              >
                <TextField
                  name="specialInstructions"
                  type="text"
                  variant="outlined"
                  size="small"
                  placeholder="Enter special instructions here"
                  onChange={(e) => handleChange({
                    target: { name: "specialInstructions", value: e?.target?.value?.replace(/[^a-zA-Z0-9\s.,#\-/;'"_&]+/gi, "")?.replace(/\s\s+/g, " ")?.trimStart()},
                  })}
                  onBlur={handleBlur}
                  slotProps={{htmlInput: {maxLength: 200}}}
                  value={values.specialInstructions}
                  multiline
                  rows={4}
                  fullWidth
                />
                <ErrorMessage
                  name="specialInstructions"
                  component="div"
                  className="error-messages"
                />
              </Grid2>
              <Grid2
                size={{ xs: 12 }}
                sx={{ mt: 2, display: "flex", justifyContent: "flex-end" , marginBottom: "1rem"}}
              >
                <Button
                  className="btn-secondary"
                  sx={{ textTransform: "none" }}
                  onClick={handleOpenPopup}
                  disabled={isDisabled}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="btn-primary"
                  sx={{ textTransform: "none", marginLeft: 1 }}
                  disabled={isDisabled}
                >
                  {packageType === "create" ? "Create Package" : "Update"}
                </Button>
              </Grid2>
            </Form>
          )}
        </Formik>
      </div>
      <AlertMessage
        open={open}
        handleClose={handleClose}
        message={alertMessage}
        severity={alertSeverity}
      />
      <SuccessDialog
        open={successOpen}
        handleClose={handleSuccessClose}
        message={alertMessage}
      />
      <ConfirmationPopup
        open={isPopupOpen}
        onClose={handleClosePopup}
        onConfirm={handleClosePopup}
        title="Cancel Confirmation"
        content="Are you sure you want to cancel? All unsaved changes will be lost."
      />
    </BasicLayout>
  );
};

export default CreatePackage;
